import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestResponse } from '../models/restResponse.mode';
import { environment } from '../../environments/environment';
import { State } from '../models/state.model';

@Injectable({
  providedIn: 'root'
})
export class StateService {
  private readonly baseUrl = `${environment.base_url}/states`;

  constructor(private http: HttpClient) {}

  getAll(search: string, paginate: boolean, page: number | null): Observable<RestResponse<State[]>> {
    return this.http.get<RestResponse<State[]>>(`${this.baseUrl}/list?search=${search}&paginate=${paginate}&page=${page}`);
  }

  getById(id: number): Observable<RestResponse<State>> {
    return this.http.get<RestResponse<State>>(`${this.baseUrl}/find/${id}`);
  }

  create(State: State): Observable<State> {
    return this.http.post<State>(`${this.baseUrl}/save`, State);
  }

  update(id: number, State: State): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/update/${id}`, State);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
  
}
